module.exports = __webpack_public_path__ + "static/media/pension.91a3d280.svg";